module.exports = __webpack_public_path__ + "img/CF_1Q.eaf72715.jpg";